import { Box, HStack, Input, Text } from "@chakra-ui/react";
import React from "react";
import { ColumnKeyEnum } from "../../constants";
import { MaterialIcon } from "../shared/MaterialIcon";

interface IProps {
  gridRef: any;
  isGridReady: boolean;
}

const RegistryFilterMode = ({ gridRef, isGridReady }: IProps) => {
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");

  const refStartDateElem = React.useRef<any>(null);
  const refEndDateElem = React.useRef<any>(null);

  const handleOnDateStartChange = (e) => {
    let setDate = "";
    if (e.target.value) {
      setDate = `${e.target.value} 00:00:00`;
    }
    setStartDate(setDate);
  };
  const handleOnDateEndChange = (e) => {
    let setDate = "";
    if (e.target.value) {
      setDate = `${e.target.value} 00:00:00`;
    }
    setEndDate(setDate);
  };

  const onFilterChanged = React.useCallback(() => {
    const gridApi = gridRef?.current?.api;

    if (gridApi) {
      const filterModel = gridApi.getFilterModel();

      if (!filterModel[ColumnKeyEnum.created_date]) {
        setStartDate("");
        setEndDate("");

        if (refStartDateElem?.current) {
          refStartDateElem.current.value = "";
        }
        if (refEndDateElem?.current) {
          refEndDateElem.current.value = "";
        }
      }
    }
  }, [gridRef, refStartDateElem, refEndDateElem]);

  React.useEffect(() => {
    const gridApi = gridRef?.current?.api;

    if (gridApi && isGridReady) {
      const currentFilters = gridApi.getFilterModel();

      let createdDateFilterModel = {};

      // Do in range filter
      if (startDate && endDate) {
        createdDateFilterModel = {
          dateFrom: startDate,
          dateTo: endDate,
          filterType: "date",
          type: "inRange",
        };
        createdDateFilterModel = {
          dateFrom: startDate,
          dateTo: endDate,
          filterType: "date",
          type: "inRange",
        };
      } else if (startDate) {
        createdDateFilterModel = {
          dateFrom: startDate,
          filterType: "date",
          type: "greaterThan",
        };
      } else if (endDate) {
        createdDateFilterModel = {
          dateFrom: endDate,
          filterType: "date",
          type: "lessThan",
        };
      }

      let filterModelUpdate = { ...currentFilters };

      if (createdDateFilterModel) {
        filterModelUpdate = {
          ...currentFilters,
          [ColumnKeyEnum.created_date]: createdDateFilterModel,
        };
      }
      gridApi.setFilterModel(filterModelUpdate);
    }
  }, [startDate, endDate, gridRef, isGridReady]);

  React.useEffect(() => {
    const gridApi = gridRef?.current?.api;

    if (gridApi) {
      gridApi.addEventListener("filterChanged", onFilterChanged);
    }

    return () => {
      if (gridApi) {
        gridApi.removeEventListener("filterChanged", onFilterChanged);
      }
    };
  }, [onFilterChanged, gridRef]);

  return (
    <Box>
      <HStack
        justifyContent={"center"}
        alignItems="center"
        py="2"
        px="6"
        bg="bg.high"
        spacing={8}
        borderTop={"1px"}
        borderColor="border"
      >
        <HStack>
          <MaterialIcon name="filter_alt" fontSize="1.5rem" variant="outline" />

          <Text fontWeight="semibold">Show me data between:</Text>
        </HStack>

        <HStack flex={1} spacing={4}>
          <Box>
            <Input
              ref={refStartDateElem}
              shadow="sm"
              size="sm"
              type="date"
              onChange={handleOnDateStartChange}
              colorScheme={"gray"}
            />
          </Box>

          <Box>
            <Input
              ref={refEndDateElem}
              shadow="sm"
              size="sm"
              type="date"
              onChange={handleOnDateEndChange}
              colorScheme={"gray"}
            />
          </Box>
        </HStack>
      </HStack>
    </Box>
  );
};

export default RegistryFilterMode;
